import React from 'react';
import { Route, Switch } from 'react-router-dom';
import PollingSiteMessage from './PollingSiteMessage';

const SiteMessage = () => (
  <Switch>
    <Route path="/search/*">
      <PollingSiteMessage page="search" />
    </Route>
    <Route path="/checkout">
      <PollingSiteMessage page="booking" />
    </Route>
    <Route path="/properties/:property_id">
      <PollingSiteMessage page="property" />
    </Route>
  </Switch>
);

export default SiteMessage;
